import { RouteParameters } from "./route-parameters";

const ADMINISTRATION_ROUTING = {
  AIRPLANES: `/dashboard/administration/airplanes`,
  AIRPLANES_CLAIM: `/dashboard/administration/airplanes/claim`,
  AIRPLANES_TRANSFER: `/dashboard/administration/airplanes/:${RouteParameters.AIRPLANE_ID}/transfer`,
  CHECKOUT: {
    [RouteParameters.CHECKOUT_ID]: {
      ROOT: `/dashboard/administration/checkout/:${RouteParameters.CHECKOUT_ID}`,
    },
  },
  ORGANIZATION: `/dashboard/administration/organization`,
  ORGANIZATION_DETAILS: `/dashboard/administration/organization-details`,
  PENDING_RISK_ASSESSMENTS: `/dashboard/administration/pending-risk-assessments`,
  PROFILE_DETAILS: `/dashboard/administration/profile-details`,
  ROOT: `/dashboard/administration`,
  SUPPORT_VEHICLES: `/dashboard/administration/support-vehicles`,
  TRANSACTIONS: `/dashboard/administration/transactions`,
  USERS: `/dashboard/administration/users`,
} as const;

export { ADMINISTRATION_ROUTING };
